import { Binding, GraphObject, Margin, Panel } from 'gojs';
import { lineageRedirectButton } from './lineage-redirect-button';

const $ = GraphObject.make;

export const groupButtons = (bindings: Binding[] = []) =>
  $(
    Panel,
    Panel.Horizontal,
    {
      margin: new Margin(0, 0, 0, 5),
    },
    ...bindings,
    lineageRedirectButton(),
  );
